import apiClient from "../../helpers/apiClient"
import { createLoadingSelector } from "./Loading"
import { arrayToObject } from "../../helpers"

export const FETCH_CMS_CONTENT = "FETCH_CMS_CONTENT"
export const FETCH_CMS_CONTENT_REQUEST = "FETCH_CMS_CONTENT_REQUEST"
export const FETCH_CMS_CONTENT_SUCCESS = "FETCH_CMS_CONTENT_SUCCESS"
export const FETCH_CMS_CONTENT_FAILURE = "FETCH_CMS_CONTENT_FAILURE"

const initialState = {
	data: {},
	didLoaded: false,
	errorMessage: "",
}
export const loadingCMSContentSelector = createLoadingSelector([FETCH_CMS_CONTENT])
export const fetchCMSContent = (path) => (dispatch) => {
	return dispatch({
		types: [
			FETCH_CMS_CONTENT_REQUEST,
			FETCH_CMS_CONTENT_SUCCESS,
			FETCH_CMS_CONTENT_FAILURE,
		],
		callAPI: (config) =>
			apiClient.get(`api/content/getListOfContents/${path}`, config),
		payload: {},
	})
}

export default function reducer(state = initialState, action) {
	const { payload, errorMessage } = action
	switch (action.type) {
		case FETCH_CMS_CONTENT_REQUEST:
			return {
				...state,
				errorMessage: "",
				successMessage: "",
			}
		case FETCH_CMS_CONTENT_SUCCESS:
			return {
				...state,
				data: payload,
				didLoaded: true,
			}
		case FETCH_CMS_CONTENT_FAILURE:
			return {
				...state,
				errorMessage,
			}
		default:
			return state
	}
}



// WEBPACK FOOTER //
// ./src/redux/modules/Content.js